// «Populyar» перед FAQ главной (29.10.2026): строки-ссылки без картинок —
// 8 самых наполненных страниц предметов, 6 направлений карты профессий,
// 2 свежие статьи и бесплатный тест. Задача — дать поиску дорогу к страницам,
// которые он находит только через sitemap. На телефоне — короче экрана.
import type { HomeLang } from "./HomePage";
import { SPHERES } from "@/careers/spheres";
import { BLOG_PATH, blogPostPath } from "@/lib/blog";
import { FREE_TEST_HREF, sphereHref } from "@/lib/seo-links";
import { subjectLabel, subjectPath } from "@/lib/tutor-subject-pages";

export type PopularData = { subjects: { code: string; n: number }[]; posts: { slug: string; title: string }[] };

export const POPULAR_SUBJECTS = 8;
export const POPULAR_SPHERES = 6;

const COPY: Record<HomeLang, { title: string; tutors: string; careers: string; blog: string; test: string; freeTest: string }> = {
  az: { title: "Populyar", tutors: "Repetitorlar", careers: "Peşələr", blog: "Bloq", test: "Test", freeTest: "Pulsuz karyera testi" },
  ru: { title: "Популярное", tutors: "Репетиторы", careers: "Профессии", blog: "Блог", test: "Тест", freeTest: "Бесплатный тест на профориентацию" },
  en: { title: "Popular", tutors: "Tutors", careers: "Careers", blog: "Blog", test: "Test", freeTest: "Free career test" },
};

export function HomePopular({ lang, data }: { lang: HomeLang; data: PopularData | null }) {
  const t = COPY[lang];
  // Самые наполненные — больше анкет; при равенстве — порядок справочника.
  const subjects = [...(data?.subjects ?? [])].sort((a, b) => b.n - a.n).slice(0, POPULAR_SUBJECTS);
  const spheres = SPHERES.slice(0, POPULAR_SPHERES);
  const posts = data?.posts ?? [];
  const row = (label: string, links: { href: string; text: string }[]) =>
    links.length > 0 && (
      <div className="hp-pop__row">
        <h3 className="hp-pop__label">{label}</h3>
        <ul className="hp-pop__links">
          {links.map((l) => (
            <li key={l.href}>
              <a href={l.href}>{l.text}</a>
            </li>
          ))}
        </ul>
      </div>
    );
  return (
    <nav className="hp-wrap hp-section hp-pop" aria-labelledby="hp-pop-h" data-home-popular="">
      <h2 id="hp-pop-h" className="hp-h2">
        {t.title}
      </h2>
      {row(t.tutors, subjects.map((s) => ({ href: subjectPath(s.code, lang), text: subjectLabel(s.code, lang) })))}
      {row(t.careers, spheres.map((s) => ({ href: sphereHref(s.slug, lang), text: s.name[lang] })))}
      {row(t.blog, posts.length ? posts.map((p) => ({ href: blogPostPath(lang, p.slug), text: p.title })) : [{ href: BLOG_PATH[lang], text: t.blog }])}
      {row(t.test, [{ href: FREE_TEST_HREF[lang], text: t.freeTest }])}
    </nav>
  );
}
